import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import { IS3FileMetaData } from "src/common/typings/s3-file-metadata";
import { downloadS3FileFromSignedURL, viewS3FileDocument } from "src/common/utils/app.s3";
import { showNotification } from "src/common/utils/app.util";

export const importFile = (apiEndpoint: string, formData: any) => async (dispatch: any) => {
  try {
    const result = await ax.post<IApi>(apiEndpoint, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (!result.data.success) {
      throw new Error(result.data.error || result.statusText);
    }
    if (result.status === 200 && result.data.success) {
      return result.data;
    }
  } catch (error: any) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const viewFile = (apiEndpoint: string, data: any) => async (dispatch: any) => {
  try {
    const res = await ax.get<IApi>(apiEndpoint, { responseType: "blob" });
    if (res.status === 200) {
      viewS3FileDocument(res.data);
    } else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const downloadFile = (apiEndpoint: string, data: any) => async (dispatch: any) => {
  try {
    const res = await ax.post<IApi & IS3FileMetaData>(apiEndpoint, data, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status === 200 && res.data.success) {
      dispatch(
        addNotificationAction({
          message: "Your download will begin shortly",
          options: { variant: "success" },
        })
      );
      downloadS3FileFromSignedURL(res.data);
    } else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const downloadFileGet = (apiEndpoint: string) => async (dispatch: any) => {
  try {
    const res = await ax.get<IApi & IS3FileMetaData>(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (res.status === 200 && res.data.success) {
      dispatch(
        addNotificationAction({
          message: "Your download will begin shortly",
          options: { variant: "success" },
        })
      );
      downloadS3FileFromSignedURL(res.data);
    } else throw new Error(res.data.error || res.statusText);
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const searchData = (apiEndpoint: string, body: any) => async (dispatch: any) => {
  try {
    const result = await ax.post<IApi>(apiEndpoint, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.status === 200 && result.data.success) {
      return result.data;
    } else throw new Error(result?.data?.error || "Error");
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};
export const searchDataWithGet = (apiEndpoint: string) => async (dispatch: any) => {
  try {
    const result = await ax.get<IApi>(apiEndpoint, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    if (result.status === 200 && result.data.success) {
      return result.data;
    } else throw new Error(result?.data?.error || "Error");
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const submitFormData =
  (apiEndpoint: string, body: any, message: string) => async (dispatch: any) => {
    try {
      const result = await ax.post<IApi>(apiEndpoint, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (result.status === 200 && result.data.success) {
        dispatch(
          addNotificationAction({
            message: message,
            options: { variant: "success" },
          })
        );
        return result.data;
      } else throw new Error(result?.data?.error || "Error");
    } catch (error) {
      if (error instanceof Error) showNotification(error.message, "error", dispatch);
      throw error;
    }
  };
export const AddData =
  (apiEndpoint: string, messageText: string, body: any) => async (dispatch: any) => {
    try {
      const result = await ax.post<IApi>(apiEndpoint, body, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (result.status === 200 && result.data.success) {
        dispatch(
          addNotificationAction({
            message: messageText,
            options: { variant: "success" },
          })
        );
        return result.data;
      } else throw new Error(result?.data?.error || "Error");
    } catch (error) {
      if (error instanceof Error) showNotification(error.message, "error", dispatch);
      throw error;
    }
  };
// made this mehtod without waiting for the api so in future we can use this method
export const InsertData = (apiEndpoint: string, body: any) => async (dispatch: any) => {
  try {
    ax.post<IApi>(apiEndpoint, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (error) {
    if (error instanceof Error) showNotification(error.message, "error", dispatch);
    throw error;
  }
};

export const sendEmailRequest =
  (apiEndpoint: string, data: any, message: string) => async (dispatch: any) => {
    try {
      dispatch(
        addNotificationAction({
          message: message,
          options: { variant: "success" },
        })
      );
      ax.post<IApi & IS3FileMetaData>(apiEndpoint, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      if (error instanceof Error) showNotification(error.message, "error", dispatch);
      throw error;
    }
  };
